export const REVISIT_THRESHOLD_DAYS = 180;
export const REVISIT_MIN_VISITS = 2;
export const REVISIT_MAX_SUGGESTIONS = 10;

const toIsoDate = (value) => (value ? String(value).slice(0, 10) : '');

const daysBetween = (fromDate, toDate) => {
  const from = new Date(`${fromDate}T00:00:00`);
  const to = new Date(`${toDate}T00:00:00`);
  if (Number.isNaN(from.getTime()) || Number.isNaN(to.getTime())) return null;
  return Math.floor((to - from) / (1000 * 60 * 60 * 24));
};

export const getRevisitSuggestions = (
  currentDate,
  visits = [],
  thresholdDays = REVISIT_THRESHOLD_DAYS,
  { minVisits = REVISIT_MIN_VISITS, limit = REVISIT_MAX_SUGGESTIONS } = {}
) => {
  const today = toIsoDate(currentDate);
  if (!today) return [];

  return (visits || [])
    .filter((visit) => (visit?.count || 0) >= minVisits)
    .map((visit) => {
      const lastDate = toIsoDate(visit?.lastDate);
      const daysSinceLastVisit = lastDate ? daysBetween(lastDate, today) : null;
      return { ...visit, lastDate, daysSinceLastVisit };
    })
    .filter((visit) => visit.daysSinceLastVisit !== null && visit.daysSinceLastVisit >= thresholdDays)
    .sort((a, b) => b.daysSinceLastVisit - a.daysSinceLastVisit)
    .slice(0, limit);
};
